var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDispatchOps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.14844,
    y: 2.5,
    width: 19,
    height: 19,
    rx: 4,
    fill: "#656565"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3807_1908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2353 7.71553C18.5285 6.90463 17.7427 6.11885 16.9318 6.41267L7.02126 9.99688C6.20765 10.2914 6.10926 11.4015 6.85773 11.8351L10.0212 13.6666L12.8461 10.8417C12.9741 10.7181 13.1455 10.6497 13.3234 10.6512C13.5013 10.6528 13.6715 10.7242 13.7974 10.85C13.9232 10.9758 13.9945 11.146 13.9961 11.3239C13.9976 11.5018 13.9292 11.6732 13.8056 11.8012L10.9807 14.6261L12.8129 17.7896C13.2458 18.5381 14.3559 18.439 14.6504 17.6261L18.2353 7.71553Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3807_1908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.2857,
    height: 16.2857,
    fill: "white",
    transform: "translate(4.50391 3.85718)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDispatchOps);
export default __webpack_public_path__ + "static/media/Dispatch Ops.34fbde123dc2d11f07ca842227defacb.svg";
export { ForwardRef as ReactComponent };